<template>
  <div class="netcall-wrap">
    <!-- p2p呼叫界面 -->
    <div class="netcall-calling-box" v-if="netcallState=='doCalling'">
      <img alt="用户头像" class="avatar" :src="sessionAvatar">
      <div class="nick">{{sessionName}}</div>
      <div class="tip">等待对方接听...</div>
      <div class="op">
        <button id="callingHangupButton" class="netcall-button red" @click="hangupFn">挂断</button>
      </div>
    </div>
    <!-- p2p视频界面 -->
    <div class="netcall-show-video" style="" v-if="netcallState=='ontime' && netcallType == 'video'">
      <div class="netcall-video-left">
        <div class="netcall-video-remote bigView">
          <div class="message"></div>
          <!-- <span class="switchViewPositionButton"></span> -->
          <div id="remoteContainer"></div>
        </div>
      </div>
      <div class="netcall-video-right" style="">
        <div class="netcall-video-local smallView">
          <div class="message">{{videoIsOpen?'':'您关闭了摄像头'}}</div>
          <!-- <span class="switchViewPositionButton"></span> -->
          <div id="container"></div>
        </div>
        <div class="operation" style="">
          <div class="control" style="">
            <div class="microphone control-item" style="">
              <!-- <div class="slider" style="">
                <el-slider v-model="cVolume" vertical width="10px" height="90px" :min="0" :max="10" @change="setCaptureVolume"></el-slider>
              </div> -->
              <span class="icon-micro" :class="{'icon-disabled':!captureIsOpen}" @click="toggleCaptureDevice"></span>
            </div>
            <div class="volume control-item" style="">
              <!-- <div class="slider" style="">
                <el-slider v-model="pVolume" vertical width="10px" height="90px" :min="0" :max="10" @change="setPlayVolume"></el-slider>
              </div> -->
              <span class="icon-volume" :class="{'icon-disabled':!playIsOpen}" @click="togglePlayDevice"></span>
            </div>
            <div class="camera control-item">
              <span class="icon-camera" @click="toggleVideoDevice" :class="{'icon-disabled':!videoIsOpen}"></span>
            </div>
          </div>
          <div class="op">
            <button class="hangupButton netcall-button red" @click="hangupFn">挂断</button>
          </div>
          <div class="tip">{{timeText}}</div>
        </div>
      </div>
    </div>
    <!-- p2p音频界面 -->
    <div class="netcall-show-audio" style="" v-if="netcallState=='ontime' && netcallType == 'audio'">
      <img alt="用户头像" class="avatar" :src="sessionAvatar">
      <div class="nick">{{sessionName}}</div>
      <div class="tip">{{timeText}}</div>
      <div class="control" style="">
        <div class="microphone control-item " style="">
          <div class="slider" style="">
            <el-slider v-model="cVolume" vertical width="10px" height="90px" :min="0" :max="10" @change="setCaptureVolume"></el-slider>
          </div>
          <span class="icon-micro" :class="{'icon-disabled':!captureIsOpen}" @click="toggleCaptureDevice"></span>
        </div>
        <div class="volume control-item" style="">
          <div class="slider" style="">
            <el-slider v-model="pVolume" vertical width="10px" height="90px" :min="0" :max="10" @change="setPlayVolume"></el-slider>
          </div>
          <span class="icon-volume" :class="{'icon-disabled':!playIsOpen}" @click="togglePlayDevice"></span>
        </div>
      </div>
      <div class="op">
        <button class="hangupButton netcall-button red" @click="hangupFn">挂断</button>
      </div>

    </div>
    <!-- 被叫界面 -->
    <div class="netcall-becalling-box" v-if="netcallState=='beCalling'">
      <img alt="用户头像" class="avatar" :src="sessionAvatar">
      <div class="nick">{{sessionName}}</div>
      <p id="becallingText" class="tip"></p>
      <div class="op">
        <div class="normal">
          <div class="checking-tip">{{callingTips}}
            <!-- <span class="netcall-icon-checking"></span> -->
          </div>
          <button class="netcall-button blue beCallingAcceptButton" id="beCallingAcceptButton" @click="response(true)">
            <span class="txt">接听</span>
            <span class="netcall-icon-checking"></span>
          </button>
          <button class="netcall-button red beCallingRejectButton" id="beCallingRejectButton" @click="response(false)">
            拒绝
          </button>
        </div>
        <div class="exception">
          <button class="netcall-button blue" id="downloadAgentButton">下载音视频插件</button>
          <br>
          <button class="netcall-button red beCallingRejectButton">拒绝</button>
          <div class="exception-tip">拒绝调用插件申请会导致无法唤起插件,需重启浏览器</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import util from '@/utils'

export default {
  data () {
    return {
      cVolume:10,
      pVolume:10,
      saveC:10,
      saveP:10,
      videoIsOpen:true,
      captureIsOpen:true,
      playIsOpen:true
    }
  },
  computed: {
    sessionAvatar () {
      let sessionId = this.currSessionId
      let user = null
      if (/^p2p-/.test(sessionId)) {
        user = sessionId.replace(/^p2p-/, '')
        let userInfo = this.userInfos[user] || {}
        return userInfo.avatar
      }
    },
    userInfos () {
      return this.$store.state.nimSDK.userInfos
    },
    sessionName () {
      let sessionId = this.currSessionId
      let user = null
      if (/^p2p-/.test(sessionId)) {
        user = sessionId.replace(/^p2p-/, '')
        if (user === this.$store.state.nimSDK.userUID) {
          return '我的手机'
        } else if (this.isRobot) {
          return this.robotInfos[user].nick
        } else {
          let userInfo = this.userInfos[user] || {}
          return util.getFriendAlias(userInfo)
        }
      } else if (/^team-/.test(sessionId)) {
        if (this.teamInfo) {
          // teamInfo中的人数为初始获取的值，在人员增减后不会及时更新，而teamMembers在人员增减后同步维护的人员信息
          var members = this.$store.state.nimSDK.teamMembers && this.$store.state.nimSDK.teamMembers[this.teamInfo.teamId]
          var memberCount = members && members.length
          return this.teamInfo.name + (memberCount ? `(${memberCount})` : '')
        } else {
          return  '群'
        }
      }
    },
    currSessionId () {
      return this.$store.state.nimSDK.currSessionId
    },
    netcallState(){
      return this.$store.state.webRTC.netcallState
    },
    netcallType(){
      return this.$store.state.webRTC.netcallType
    },
    timeText(){
      return this.$store.state.webRTC.timeText
    },
    callingTips(){
      switch(this.netcallType){
        case "video":
          return "邀请视频通话...";
        case "audio":
          return "邀请语音通话...";
      }
    }
  },
  created:function(){
    if(!this.$store.state.nimSDK.nim){
      this.$router.go(-1);
    }
    window.onbeforeunload = () => {
      if(this.netcallState == "beCalling"){
        this.response(false);
      }else{
        this.hangupFn();
      }
    }
  },
  methods: {
    hangupFn(){
      this.$store.dispatch("hangup");
    },
    response(accepted){
      this.$store.dispatch("response",{
        accepted:accepted
      });
    },
    setCaptureVolume(value){
      var volume = parseInt(value*255/10);
      this.captureIsOpen = value>0?true:false
      this.$store.dispatch("setCaptureVolume",volume)
    },
    setPlayVolume(value){
      var volume = parseInt(value*255/10);
      this.playIsOpen = value>0?true:false
      this.$store.dispatch("setPlayVolume",volume)
    },
    toggleVideoDevice(){
      this.videoIsOpen = this.videoIsOpen?false:true;
      this.$store.dispatch("toggleVideoDevice",this.videoIsOpen?"open":"close")
    },
    toggleCaptureDevice(){
      this.captureIsOpen = this.captureIsOpen?false:true;
      if(this.captureIsOpen){
        this.cVolume = this.saveC
      }else{
        this.saveC = this.cVolume
        this.cVolume = 0
      }
      this.setCaptureVolume(this.cVolume)
    },
    togglePlayDevice(){
      this.playIsOpen = this.playIsOpen?false:true;
      if(this.playIsOpen){
        this.pVolume = this.saveP
      }else{
        this.saveP = this.pVolume
        this.pVolume = 0
      }
      this.setPlayVolume(this.pVolume)
    }
  },
  destroyed(){
    window.onbeforeunload = null;
  }
}
</script>



// WEBPACK FOOTER //
// src/components/netcall.vue